import type { ScenarioPackage } from "@mobile/runtime/types";

export interface WebScenarioHeadingSupport {
  language: string;
  title?: string;
  microSkill?: string;
  intentTitlesById: Record<string, string>;
}

interface ScenarioWithHeadingSupport extends ScenarioPackage {
  headingSupport?: WebScenarioHeadingSupport;
}

export function getWebScenarioHeadingSupport(
  scenario: ScenarioPackage,
  supportLanguage: string,
): WebScenarioHeadingSupport | undefined {
  const support = (scenario as ScenarioWithHeadingSupport).headingSupport;
  return support?.language === supportLanguage && supportLanguage !== scenario.targetLanguage ? support : undefined;
}

export function mergeWebScenarioOverlay(
  base: ScenarioPackage,
  overlay: Partial<ScenarioPackage> | null,
  supportLanguage: string,
): ScenarioWithHeadingSupport {
  if (!overlay || supportLanguage === base.targetLanguage) return base;
  const intentTitlesById: Record<string, string> = {};
  for (const [index, intent] of (base.intentSystem || []).entries()) {
    const localized = overlay.intentSystem?.find((entry) => entry.intentId === intent.intentId)
      || (base.intentSystem?.length === overlay.intentSystem?.length ? overlay.intentSystem?.[index] : undefined);
    const title = localized?.title?.trim();
    if (title) intentTitlesById[intent.intentId] = title;
  }
  return {
    ...base,
    headingSupport: {
      language: supportLanguage,
      title: overlay.title?.trim() || undefined,
      microSkill: overlay.microSkill?.trim() || undefined,
      intentTitlesById,
    },
  };
}
